import React, { useEffect, useState } from 'react';
import { Dropdown, Flex, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { ShopProps } from '../service/shop.interface';
import { SpodialIcon } from '../../../../../shared/ui/Icons/SpodialIcon';
import { WildberriesIcon } from '../../../../../shared/ui/Icons/WildberriesIcon';
import { OzonIcon } from '../../../../../shared/ui/Icons/OzonIcon';
import { setShopCurrent } from '../store/shopSlice';
import { useAppDispatch } from '../../../../../store';
import { useLazyReadShopsQuery } from '../service/shops';

export const ShopSelector = ({
    id,
    name,
    type,
    readonly = false,
}: {
    id: ShopProps['id'];
    name: ShopProps['name'];
    type: ShopProps['type'];
    readonly?: boolean;
}) => {
    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        limit: 1000,
        offset: 0,
        name: '',
    });

    const [list, setList] = useState([]);

    const dispatch = useAppDispatch();
    const [getShops, { data: shops, isSuccess }] = useLazyReadShopsQuery();

    useEffect(() => {
        getShops(filters, false);
    }, []);

    useEffect(() => {
        if (shops && isSuccess) {
            setList(shops.items);
        }
    }, [shops, isSuccess]);

    useEffect(() => {
        if (id === undefined && list.length > 0) {
            dispatch(setShopCurrent(list[0]));
        }
    }, [id, list]);

    const selectShop = (item: ShopProps) => {
        if (!readonly) dispatch(setShopCurrent(item));
    };

    const renderIconByType = (type: ShopProps['type']) => {
        const icons: Record<number, JSX.Element> = {
            0: <SpodialIcon />,
            1: <WildberriesIcon />,
            2: <OzonIcon />,
        };
        return icons[type] ?? null;
    };

    const content = (
        <Flex gap={4} style={{ cursor: readonly ? 'default' : 'pointer' }}>
            <Flex gap={8} align='center'>
                <div style={{ width: 38, height: 38 }}>
                    {renderIconByType(type)}
                </div>
                <Typography.Title style={{ margin: 0 }} level={2}>
                    {name}
                </Typography.Title>
            </Flex>
            {!readonly && <DownOutlined size={24} />}
        </Flex>
    );

    const getItems = (shops: ShopProps[]) =>
        shops.map(shop => ({
            key: shop.id,
            label: (
                <Flex align='center' gap={8} onClick={() => selectShop(shop)}>
                    <div style={{ width: 24, height: 24 }}>
                        {renderIconByType(shop.type)}
                    </div>
                    <Typography.Text>{shop.name}</Typography.Text>
                </Flex>
            ),
        }));

    if (readonly) return content;

    return (
        <Flex gap={8} onClick={() => setOpen(!open)}>
            <Dropdown
                open={open}
                dropdownRender={menu => (
                    <div
                        style={{
                            maxHeight: 300,
                            minWidth: 322,
                            maxWidth: 322,
                            overflowY: 'auto',
                            boxShadow:
                                '0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                        }}
                    >
                        {menu}
                    </div>
                )}
                menu={{ items: getItems(list) }}
            >
                {content}
            </Dropdown>
        </Flex>
    );
};
